/**
 * Created by vladislav on 6/5/19
 *
 * ShopWindow is a prefab window (Prefab.createWindow). Behavior lives in
 * ShopWindowController / ShopWindowPropertySource (+ for units shops,
 * Merge2UnitsShopController / UnitsShopController attached conditionally by
 * ShopWindowController). Per-UI layout lives in res/ui/${ui}/tile_shop/shopwindow.prefab.json.
 *
 * Window identity: a createWindow node is a plain cc.Node, so instead of
 * `window instanceof ShopWindow` use ComponentUtils.findComponentByName(window, "ShopWindowController")
 * (the controller lives on the Resizable sub-prefab node, not the window node).
 */

const ShopWindow = Prefab.createWindow("tile_shop", "shopwindow_prefab_json", {
    loadingTasks: function (options) {
        options = options || {};

        if (options.tab === ShopWindow.TABS.HARD_CURRENCY && connector.platform.oneOf(connector.G5WINDOWS)) {
            return [(onSuccess) => {
                const plugin = connector.payments.getPlugin();
                plugin._loadProducts(cleverapps.waitNoMore(500, onSuccess));
            }];
        }

        return [];
    }
});

// Legacy subclasses become plain factory functions. A function invoked with `new`
// that returns an object yields that object, so `new X()`, `onClickWindow: () => X`
// and focus:"X" keep working.
const LivesShopWindow = function (options) {
    options = options || {};
    return new ShopWindow({
        tab: ShopWindow.TABS.LIVES,
        onClose: options.onClose,
        force: options.force
    });
};

const EnergyShopWindow = function (options) {
    options = options || {};
    return new ShopWindow({
        tab: ShopWindow.TABS.ENERGY,
        onClose: options.onClose,
        force: options.force
    });
};

const SoftCurrencyShopWindow = function (options) {
    options = options || {};
    return new ShopWindow({
        tab: ShopWindow.TABS.SOFT_CURRENCY,
        force: options.force
    });
};

const HardCurrencyShopWindow = function (options) {
    options = options || {};
    return new ShopWindow({
        tab: ShopWindow.TABS.HARD_CURRENCY,
        attention: options.attention
    });
};

ShopWindow.TABS = {
    HARD_CURRENCY: 0,
    LIVES: 1,
    SOFT_CURRENCY: 2,
    UNITS_FRUIT: 3,
    UNITS_RESOURCE: 4,
    UNITS_DISCOUNT: 5,
    // UNITS_EXPEDITION_HALLOWEEN: 6,
    ENERGY: 7,
    // UNITS_EXPEDITION_XMAS: 8,
    // UNITS_EXPEDITION_DRAGONIA: 10,
    // UNITS_EXPEDITION_UNDERSEA: 12,
    // UNITS_EXPEDITION_UNDERSEA2: 13,
    UNITS_ADS: 14,
    UNITS_ADS_VIP: 15,
    FOGS_VALUABLES: 20
    // UNITS_EXPEDITION_DRAGONIA2: 21,
    // UNITS_EXPEDITION_RAPUNZEL: 22,
    // UNITS_EXPEDITION_EASTER: 23,
    // UNITS_EXPEDITION_COLLECTIONS: 24,
    // UNITS_EXPEDITION_DRAGONIA3: 25,
    // UNITS_EXPEDITION_CHINA: 26,
    // UNITS_EXPEDITION_BLACKFRIDAY: 27,
    // UNITS_EXPEDITION_SPRING: 28,
    // UNITS_EXPEDITION_UNDERSEA3: 29,
    // UNITS_EXPEDITION_RAPUNZEL2: 30,
    // UNITS_EXPEDITION_RAPUNZEL3: 31,
    // UNITS_EXPEDITION_GRADUATION: 32,
    // UNITS_EXPEDITION_CANDY: 33,
    // UNITS_EXPEDITION_MUSICFEST: 34,
    // UNITS_EXPEDITION_JULY4: 35,
    // UNITS_EXPEDITION_STARTALE: 36,
    // UNITS_EXPEDITION_SUMMERPETS: 37,
    // UNITS_EXPEDITION_LABORDAY: 38
};

ShopWindow.getUnitsController = function (window) {
    return ComponentUtils.findComponentByName(window, cleverapps.config.type === "merge2" ? "Merge2UnitsShopController" : "UnitsShopController");
};

ShopWindow.HEADING_TABS_CONFIG = [{
    id: ShopWindow.TABS.HARD_CURRENCY,
    icon: bundles.reward_icons.frames.gold_small_png,
    text: "ShopWindow.tabDiamond"
}, {
    id: ShopWindow.TABS.SOFT_CURRENCY,
    icon: bundles.reward_icons.frames.coin_small_png,
    text: "ShopWindow.tabCoin"
}];

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    TILE_SHOP_BADGE_STROKE: {
        color: new cc.Color(100, 34, 22, 255),
        size: 2
    },

    TILE_SHOP_SHADOW: {
        color: new cc.Color(100, 34, 22, 200),
        direction: cc.size(0, -3),
        blur: 1
    },

    TILE_SHOP_STROKE: {
        color: new cc.Color(100, 34, 22, 255),
        size: 3
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SHOP_WINDOW_TABS_TEXT_FONT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(24, 92, 209, 255),
            size: 2
        }
    },

    SHOP_WINDOW_TABS_TEXT_FONT_DISABLED: {
        size: 40,
        color: new cc.Color(182, 99, 55, 255)
    },

    SHOP_WINDOW_HEADER_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    }
});

// Base font for the shop-tile "left text" (energy/time info). The per-UI *uistyles.js files
// (only heroes today) override it; this is the default for every other UI. Lived in the deleted
// baseproducttile.js - kept here so tile prefabs binding "SHOPTILE_LEFT" resolve on all UIs.
cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SHOPTILE_LEFT: {
        size: 32,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

// TILE_SHOP_OFFER_TEXT is the rewards-text fallback font that used to live in the old shop-tile
// block views (tilebutton.js / tilerewardsblock.js), now deleted. Registered here as the base so the
// per-UI *uistyles.js overrides of it (and PACK_TILE_REWARDS_TEXT, which falls back to it) resolve.
cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TILE_SHOP_OFFER_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

// Base font for the pack/offer rewards block. wooden/tropic (and all aisensia UIs) override it;
// the other UIs (riddles/heroes) had no definition and the old PackProductTile fell back to
// TILE_SHOP_OFFER_TEXT inside TileRewardsBlock - the prefab rewardsList has no such fallback, so
// register that same value as the base here to keep riddles/heroes rendering identically.
cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PACK_TILE_REWARDS_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

// Base fonts for the premium-tile rewards block (subscription / growthFund). All cleverapps UIs
// override them; this is the default for any UI that doesn't. Lived in the deleted subscriptiontile.js.
cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TILE_REWARDS: {
        name: "default",
        size: 45,
        color: cleverapps.styles.COLORS.WHITE
    },

    TILE_REWARDS_HEADER: {
        name: "default",
        size: 35,
        color: cleverapps.styles.COLORS.WHITE
    }
});

// Base font for the tile limit text (all cleverapps UIs override it, this is the default for
// any UI that doesn't). Lived in the deleted coinsproducttile.js.
cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PRODUCT_TILE_LIMIT_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});
